export default "__VITE_ASSET__BI2$iu6v__"